import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { getArtisanStatsAction } from '../../../modules/statistics/Actions';
import Stats from './Stats';
import getLangData from '../../../utils/getLangData';
import AdBanner from '../../ads/AdBanner';

const AdminStaticBar = ({ currentUser, getArtisanStatsAction, adminStats }) => {
  const statsTranslate = getLangData().stats;
  const profileTranslate = getLangData().profile_types;
  console.log(adminStats, 'adminStats');
  return (
    <>
      <Stats
        title={statsTranslate.total}
        sections={[
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.applicants,
            item: {
              count: adminStats?.applicants
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.artisan_jobs,
            item: {
              count: adminStats?.artisanJobs
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.supplier_jobs,
            item: {
              count: adminStats?.supplierJobs
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: profileTranslate.customer,
            item: {
              count: adminStats?.customers
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: profileTranslate.artisan,
            item: {
              count: adminStats?.artisans
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: profileTranslate.supplier,
            item: {
              count: adminStats?.suppliers
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: profileTranslate.training_center,
            item: {
              count: adminStats?.trainingCenters
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.artisan_private_inquiry,
            item: {
              count: adminStats?.privateArtisanInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.artisan_public_inquiry,
            item: {
              count: adminStats?.publicArtisanInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.supplier_public_inquiry,
            item: {
              count: adminStats?.privateSupplierInquiries
            }
          },
          {
            icon: 'icon icon-inquiries-warshatna',
            title: statsTranslate.supplier_public_inquiry,
            item: {
              count: adminStats?.publicSupplierInquiries
            }
          }
        ]}
      />
      <AdBanner />
    </>
  );
};
const mapStateToProps = (state, props) => {
  return {
    adminStats: state.stats.adminStats,
    currentUser: state.users.currentUser
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    //   getArtisans: getArtisansAction,
    getArtisanStatsAction
  })(AdminStaticBar)
);
